import { ROUTES } from '@/core/constants/routes'
import { cn } from '@/core/lib/utils/cn'
import { getCitySlugs } from '@/features/cities/providers/server'
import { Link } from '@/i18n/navigation'
import { Navbar, NavbarBrand, NavbarContent, NavbarItem } from '@heroui/navbar'
import { getTranslations } from 'next-intl/server'
import dynamic from 'next/dynamic'
import { Logo } from '../atoms/logo'

import { NavLinks } from './nav-links'

const HeaderDrawer = dynamic(() =>
  import('./header-drawer').then(mod => mod.HeaderDrawer),
)
const CitiesDropdown = dynamic(() =>
  import('./cities-dropdown').then(mod => mod.CitiesDropdown),
)
const HeaderActions = dynamic(() =>
  import('./customer-header-actions').then(mod => mod.HeaderActions),
)

type Props = {
  theme?: 'red' | 'blue'
  className?: string
  showNav?: boolean
  sticky?: boolean
  shadow?: boolean
}

export const CustomerHeader: React.FC<Props> = async ({
  theme = 'blue',
  className = '',
  sticky = false,
  showNav,
  shadow,
}) => {
  const t = await getTranslations()
  const citySlugs = getCitySlugs()

  const headerClasses = cn(
    'flex w-full items-center justify-between font-medium z-40',
    theme === 'red' && 'text-white',
    theme === 'blue' && 'text-navy',
    shadow && 'shadow-xs',
    theme === 'red' && shadow && 'shadow-white',
    theme === 'blue' && shadow && 'shadow-navy',
    className,
  )

  return (
    <Navbar
      maxWidth='full'
      position={sticky ? 'sticky' : 'static'}
      isBlurred={false}
      classNames={{
        base: headerClasses,
        wrapper: 'px-0',
      }}
    >
      <NavbarBrand className='!shrink-0 !grow-0 !basis-auto'>
        <Link href={ROUTES.home} aria-label={t('ariaLabels.goHome')} passHref>
          <span>
            <Logo theme={theme} />
          </span>
        </Link>
      </NavbarBrand>
      {showNav ? (
        <NavbarContent
          justify='center'
          className='hidden justify-center md:flex'
        >
          <NavLinks />
          <CitiesDropdown citySlugs={citySlugs} />
        </NavbarContent>
      ) : null}
      <NavbarContent justify='end' className='!grow-0'>
        <HeaderActions />
        {showNav ? (
          <NavbarItem className='md:hidden'>
            <HeaderDrawer citySlugs={citySlugs} />
          </NavbarItem>
        ) : null}
      </NavbarContent>
    </Navbar>
  )
}
